import React from 'react'
import styles from './HeaderSpacer.module.css'


export const HeaderSpacer = ({ children }) => <div className={styles.spacer}>{children}</div>